import type { i18n as I18n } from 'i18next';
import { Suspense } from 'react';

import { Spinner } from '@/shared/ui';

import { AppProviders } from './providers';
import { AppRoutes } from './router/routes';
import { ScrollToTop } from './router/ScrollToTop';

/**
 * Application shell: contexts, routes and the lazy-route fallback.
 *
 * The router is supplied by the caller — a BrowserRouter in the browser, a
 * StaticRouter when prerendering — each with the locale's basename.
 */
export const App = ({ i18n }: { i18n: I18n }) => (
  <AppProviders i18n={i18n}>
    <ScrollToTop />
    <div className="flex min-h-screen flex-col bg-white font-sans selection:bg-primary/20 selection:text-primary">
      <Suspense
        fallback={
          <div className="flex flex-1 items-center justify-center py-32">
            <Spinner size="lg" />
          </div>
        }
      >
        <AppRoutes />
      </Suspense>
    </div>
  </AppProviders>
);
